import React from 'react';
const DashboardInfoCard = ({ icon, title, value, downtext }) => {
  return (
    <div className="w-full h-auto min-h-[96px] bg-white dark:bg-shoorah-darkBgTabColor rounded-[8px] dark:border-none border-[1.5px] border-shoorah-borderGray flex flex-col items-center p-5">
      <div className="flex flex-row items-center w-full">
        <div className="flex justify-center items-center">{icon}</div>
        <div className="flex flex-col text-start ml-4">
          <p className="text-[14px] font-medium tracking-tight text-shoorah-lightBlack dark:text-shoorah-darkBg">
            {title}
          </p>
          <p className="text-[24px] font-bold text-shoorah-lightBlack dark:text-shoorah-darkBg line-clamp-1 break-all">
            {value}
          </p>
        </div>
      </div>
      {downtext && (
        <div className='text-[#6A9F69] text-xs font-normal mr-auto mt-2'>{downtext}</div>
      )}
    </div>
  );
};
export default DashboardInfoCard;